<z-select
    id="{{ id() }}"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder()"
    [class]="class"
    [label]="showLabel() == true ? label() : ''"
    [showClear]="showClear()"
    [filter]="filter()"
    [class]="class"
    [ngModel]="model"
    (ngModelChange)="modelChange($event)"
    [ngModelOptions]="{ standalone: true }"
/>
